// Llevar la vista al resultado recién calculado y anunciarlo.
//
// Ojo con `behavior: "smooth"`: hay contextos donde no se aplica y la llamada
// queda en nada, dejando el resultado fuera de la pantalla sin ningún aviso.
// Por eso siempre va una red de seguridad que, si el elemento no quedó donde
// tenía que quedar, hace el salto instantáneo.

// Cuánto de la parte de arriba de la pantalla está tapado por algo fijo.
//
// AdSense pone anuncios de ancla en `position: fixed` con el z-index más alto
// posible. Medido en /mapa-astral/ a 375px el 2026-10-21: 411px de alto pegados
// arriba, el 51% de la pantalla. Dejar el resultado en y=0 lo metía justo debajo
// de ese anuncio: el usuario apretaba "Calcular" y veía publicidad donde tenía
// que estar su Sol, su Lua y su ascendente.
//
// En vez de adivinar una altura, se pregunta qué hay realmente en el punto de
// arriba: elementsFromPoint devuelve la pila, y de ahí sale el borde inferior de
// lo que esté fijo. Si no hay nada, da 0 y el resultado va arriba de todo como
// siempre. También cubre cualquier barra fija que el sitio tenga en el futuro.
const alturaTapadaArriba = () => {
  try {
    const pila = document.elementsFromPoint(Math.round(window.innerWidth / 2), 2) || []
    let abajo = 0
    for (const el of pila) {
      const pos = window.getComputedStyle(el).position
      if (pos !== "fixed" && pos !== "sticky") continue
      const r = el.getBoundingClientRect()
      if (r.top <= 4 && r.bottom > abajo) abajo = r.bottom
    }
    // Si algo ocupa casi toda la pantalla no hay nada que esquivar: empujar el
    // resultado tan abajo sería peor que dejarlo arriba.
    return abajo > window.innerHeight * 0.75 ? 0 : Math.round(abajo)
  } catch (_) {
    return 0
  }
}

export const mostrarResultado = el => {
  if (!el || typeof window === "undefined") return
  const reduzMovimento =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches

  const destino = () => {
    const r = el.getBoundingClientRect()
    const y = window.scrollY + r.top - alturaTapadaArriba() - 8
    return Math.max(0, Math.round(y))
  }

  const ir = suave => {
    try {
      window.scrollTo({ top: destino(), behavior: suave ? "smooth" : "auto" })
    } catch (_) {
      // Navegadores viejos sin opciones en scrollTo.
      window.scrollTo(0, destino())
    }
  }

  ir(!reduzMovimento)

  // Si pasado el suspiro no quedó donde tenía que quedar —porque el scroll suave
  // no se aplicó, o porque el anuncio de ancla apareció después y cambió la
  // altura tapada— se recalcula y se salta.
  window.setTimeout(() => {
    const falta = Math.abs(window.scrollY - destino())
    if (falta > 8) ir(false)
  }, 450)

  try {
    el.focus({ preventScroll: true })
  } catch (_) {
    if (typeof el.focus === "function") el.focus()
  }
}
